const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLangRo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 999,
    height: 666,
    viewBox: "0 0 999 666",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.325)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#00319c"
    },
    height: 80,
    width: 40,
    y: 0,
    x: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffde00"
    },
    height: 80,
    width: 40,
    y: 0,
    x: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#de2110"
    },
    height: 80,
    width: 40,
    y: 0,
    x: 80
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangRo);
export default __webpack_public_path__ + "static/media/lang-ro.d4bca6dac823e5b8426a85bcc75fe101.svg";
export { ForwardRef as ReactComponent };